import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import { menuManagementListQueryParams } from '@/services/Service/MenuManagementList';

import {
  BrandMenuListResponse,
  MenuManagementBrandMenuCreateParams,
  MenuManagementBrandMenuListParams,
  MenuManagementBrandMenuSearchParams,
  MenuManagementMenuUpdateParams,
  SearchBrandMenuResponse,
  ShowMenuResponse,
} from './hooks';

export type SearchItem = {
  id: string;
  name: string;
};

interface Interface {
  create: (params: MenuManagementBrandMenuCreateParams) => Promise<void>;
  list: (
    params: MenuManagementBrandMenuListParams
  ) => Promise<BrandMenuListResponse>;
  show: (id: string) => Promise<ShowMenuResponse>;
  update: (id: string, params: MenuManagementMenuUpdateParams) => Promise<void>;
  delete: (id: string) => Promise<void>;
  search: (
    params: MenuManagementBrandMenuSearchParams
  ) => Promise<SearchBrandMenuResponse[]>;
}

export class MenuManagementBrandMenuService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async create(
    params: MenuManagementBrandMenuCreateParams
  ): Promise<void> {
    await this.restClient.post<MenuManagementBrandMenuCreateParams, void>(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-menus` as const,
      params
    );
  }

  public async list(
    params: MenuManagementBrandMenuListParams
  ): Promise<BrandMenuListResponse> {
    const query = menuManagementListQueryParams(params);
    return await this.restClient.get<BrandMenuListResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-menus${query}` as const
    );
  }

  public async show(id: string): Promise<ShowMenuResponse> {
    return await this.restClient.get<ShowMenuResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-menus/${id}` as const
    );
  }

  public async update(
    id: string,
    params: MenuManagementMenuUpdateParams
  ): Promise<void> {
    return await this.restClient.patch(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-menus/${id}` as const,
      params
    );
  }

  public async delete(id: string): Promise<void> {
    return await this.restClient.delete(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-menus/${id}` as const
    );
  }

  public async search(
    params: MenuManagementBrandMenuSearchParams
  ): Promise<SearchBrandMenuResponse[]> {
    const query =
      `?associate_brand_id=${params.associate_brand_id.toString()}` as const;

    return await this.restClient.get(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-menus/search${query}` as const
    );
  }
}
